import * as React from "react";
import {updateOrderItemState} from "../retry/fetchers";
import Alert from "../../../Common/Alert";
import { AxumOperationType, OrderStates } from "../../../../types/orders/order";
import { FeaturesAllowedName } from "../../../../utils/commonFetchers";

export default (props: any) => {
  const { dataItem, parentRow } = props;
  const [anulado, setAnulado] = React.useState(dataItem.deleted);

  const isRejectedOrder = parentRow.erpState.toLowerCase() === OrderStates.ENVIO_RECHAZADO || parentRow.erpState.toLowerCase() === OrderStates.ERROR_AL_ENVIAR;
  const isDownloadPending = parentRow.erpState.toLowerCase() === OrderStates.NUEVO && parentRow.axumOperationTypeCode === AxumOperationType.PRESUPUESTO;
  
  const featuresAllowedToAction = (props.featuresAllowed as string[]).find(x => x === FeaturesAllowedName.BUDGETS);

    const [text, setText] = React.useState('');
    const [show, setShow] = React.useState(false);
    const close = () => {
        setShow(false);
    }

  if (isRejectedOrder  || (isDownloadPending && featuresAllowedToAction))
  {
    if(!anulado)
    {   
      return (
        <td className="k-command-cell">
            <Alert success={false} text={text} show={show} close={close}></Alert>
            <button
              type="button"
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command"
              onClick={() => updateOrderItemState(false, dataItem.id).then(x => {
                    const updateOrderStateSuccess = !(x.notUpdated > 0);
                    if(updateOrderStateSuccess){
                      dataItem.deleted= true;
                      setAnulado(true);
                    }
                    else
                    {
                      setText(x.error);
                      setShow(true);
                    }
                })}
            >
              Anular
            </button>
        </td>
      );
    } 
    else
    {
      return (
        <td className="k-command-cell">
            <Alert success={false} text={text} show={show} close={close}></Alert>
            <button
              type="button"
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command"
              onClick={() => updateOrderItemState(true, dataItem.id).then(x => {
                 const updateOrderStateSuccess = !(x.notUpdated > 0);
                    if(updateOrderStateSuccess){
                      dataItem.deleted= false;
                      setAnulado(false);
                    }
                    else
                    {
                      setText(x.error);
                      setShow(true);
                    }
                })}
            >
              Desanular
            </button>
        </td>
      );
    }
  }
  else{return <></>}
};
